module.exports = __webpack_public_path__ + "img/hero.e7b6a75b.png";